import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";

/**
 * Fields type definition for content type 'TypeEmbedZohoForm'
 * @name TypeEmbedZohoFormFields
 * @type {TypeEmbedZohoFormFields}
 * @memberof TypeEmbedZohoForm
 */
export interface TypeEmbedZohoFormFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'publicUrl' (publicUrl)
     * @name publicUrl
     * @localized false
     */
    publicUrl: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'width' (width)
     * @name width
     * @localized false
     */
    width: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'height' (height)
     * @name height
     * @localized false
     */
    height: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'zoomWebinarId' (Zoom Webinar Id)
     * @name Zoom Webinar Id
     * @localized false
     */
    zoomWebinarId?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'ask_persona' (Zoom Ask Persona)
     * @name Zoom Ask Persona
     * @localized false
     */
    ask_persona?: EntryFieldTypes.Boolean;
    /**
     * Field type definition for field 'ask_channel' (Zoom Ask Channel)
     * @name Zoom Ask Channel
     * @localized false
     */
    ask_channel?: EntryFieldTypes.Boolean;
    /**
     * Field type definition for field 'ask_speaker_questions' (Zoom Ask Qs for Speakers/MW)
     * @name Zoom Ask Qs for Speakers/MW
     * @localized false
     */
    ask_speaker_questions?: EntryFieldTypes.Boolean;
    /**
     * Field type definition for field 'ask_sgrid_apply' (Zoom Ask Applied to S-Grid)
     * @name Zoom Ask Applied to S-Grid
     * @localized false
     */
    ask_sgrid_apply?: EntryFieldTypes.Boolean;
    /**
     * Field type definition for field 'ask_resource_updates' (Zoom Ask Resource Updates)
     * @name Zoom Ask Resource Updates
     * @localized false
     */
    ask_resource_updates?: EntryFieldTypes.Boolean;
    /**
     * Field type definition for field 'ask_transform_apply' (Zoom Ask Applied to TRANSFORM)
     * @name Zoom Ask Applied to TRANSFORM
     * @localized false
     */
    ask_transform_apply?: EntryFieldTypes.Boolean;
}

/**
 * Entry skeleton type definition for content type 'embedZohoForm' (Embed Zoho Form)
 * @name TypeEmbedZohoFormSkeleton
 * @type {TypeEmbedZohoFormSkeleton}
 * @author 1elSikqsztE4ExkC29eZFE
 * @since 2019-08-01T11:59:48.995Z
 * @version 35
 */
export type TypeEmbedZohoFormSkeleton = EntrySkeletonType<TypeEmbedZohoFormFields, "embedZohoForm">;
/**
 * Entry type definition for content type 'embedZohoForm' (Embed Zoho Form)
 * @name TypeEmbedZohoForm
 * @type {TypeEmbedZohoForm}
 * @author 1elSikqsztE4ExkC29eZFE
 * @since 2019-08-01T11:59:48.995Z
 * @version 35
 */
export type TypeEmbedZohoForm<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeEmbedZohoFormSkeleton, Modifiers, Locales>;

export function isTypeEmbedZohoForm<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeEmbedZohoForm<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'embedZohoForm'
}
